<template>
  <section class="section">
    <div class="container">
      <div class="columns">
        <div class="column">
          <h2 class="title">
            Department of Agriculture Clinic/ Productivity Report
          </h2>
        </div>
      </div>
      <b-tabs v-model="activeTab" v-if="roleid == 10 || roleid == 9">
        <b-tab-item label="ສິນຄ້າທັງໝົດ">
          <div class="columns">
            <div class="column">
              <div class="columns">
                <div class="column">
                  <b-field label="ຄົ້ນຫາສິນຄ້າ">
                    <input
                      type="text"
                      class="input"
                      v-model="search"
                      v-on:keyup="productSearch"
                    />
                  </b-field>
                </div>
                <div class="column">
                  <b-field label="ປະເພດສິນຄ້າ">
                    <Multiselect
                      placeholder="ເລືອກ"
                      v-model.trim="selectedTypeSearch"
                      label="NAME"
                      track-by="ID"
                      :options="typeList"
                      @input="productTypeSelectedSearch"
                    >
                    </Multiselect>
                  </b-field>
                </div>
                <div class="column">
                  <b-field label="ເກັບກ່ຽວ">
                    <Multiselect
                      placeholder="ເລືອກ"
                      v-model.trim="selectedHarvestSearch"
                      label="NAME"
                      track-by="ID"
                      :options="harvesttype"
                      @input="onHarvestSearch"
                    >
                    </Multiselect>
                  </b-field>
                </div>
                <div class="column"></div>
                <div class="column"></div>
                <div class="column"></div>
              </div>
              <!-- <b-field style="margin-left: 20px" grouped>
                
                
                
              </b-field> -->

              <b-field label="ສິນຄ້າທັງໝົດ">
                <table class="table is-fullwidth is-narrow is-small">
                  <thead>
                    <tr>
                      <th class="has-text-centered " width="5%">#</th>
                      <th class="has-text-left " width="15%">
                        ປະເພດ
                      </th>
                      <th class="has-text-left " width="15%">
                        ສິນຄ້າ
                      </th>

                      <th class="has-text-left " width="15%">
                        ຫົວໜ່ວຍ
                      </th>
                      <th class="has-text-left " width="15%">
                        ເກັບກ່ຽວ
                      </th>
                      <th class="has-text-left " width="15%">
                        ຮູບ
                      </th>
                      <th class="has-text-centered " width="10%">
                        ຈັດການ
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(data, index) in activeproducts"
                      :key="data.PRODUCTID"
                    >
                      <td class="has-text-centered">{{ index + 1 }}</td>
                      <td>
                        {{ data.PRODUCTTYPENAME }}
                      </td>
                      <td>
                        {{ data.PRODUCTNAME }}
                      </td>
                      <td>
                        {{ data.UNIT }}
                      </td>
                      <td>
                        {{ data.HARVESTONENAME }}
                      </td>
                      <td>
                        <!-- {{data.PHOTONAME}} -->
                        <img
                          data-v-xcxcc
                          :src="getImgUrl(data.PHOTONAME)"
                          width="100"
                          height="100"
                        />
                      </td>

                      <td class="has-text-centered">
                        <b-field group>
                          <b-field>
                            <b-button
                              class="btn-group-margin"
                              type="is-info"
                              size="is-small"
                              @click="productivityForm(data)"
                              >ຄວາມສາມາດຜະລິດ
                            </b-button>
                          </b-field>

                          <b-field>
                            <b-button
                              class="btn-group-margin"
                              type="is-primary"
                              size="is-small"
                              @click="seedForm(data)"
                              >ອັດຕາສ່ວນແນວພັນ
                            </b-button>
                          </b-field>
                          <b-field>
                            <b-button
                              class="btn-group-margin"
                              type="is-danger"
                              size="is-small"
                              @click="recommendForm(data)"
                              >ຄຳແນະນຳການຜະລິດ
                            </b-button>
                          </b-field>
                        </b-field>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </b-field>
            </div>
          </div>
        </b-tab-item>

        <b-tab-item label="ຄວາມສາມາດຜະລິດ">
          <div class="columns scrollme">
            <div class="column">
              <b-field :label="tabproductivitytitle">
                <b-tabs v-model="activeSubTab">
                  <table class="table is-fullwidth is-narrow is-small">
                    <thead>
                      <tr>
                        <th class="has-text-left " width="15%">
                          ໂຊນຜະລິດກະສິກຳ
                        </th>
                        <th class="has-text-right " width="5%">
                          01
                        </th>
                        <th class="has-text-right " width="5%">
                          02
                        </th>
                        <th class="has-text-right " width="5%">
                          03
                        </th>
                        <th class="has-text-right " width="5%">
                          04
                        </th>
                        <th class="has-text-right " width="5%">
                          05
                        </th>
                        <th class="has-text-right " width="5%">
                          06
                        </th>
                        <th class="has-text-right " width="5%">
                          07
                        </th>
                        <th class="has-text-right " width="5%">
                          08
                        </th>
                        <th class="has-text-right " width="5%">
                          09
                        </th>
                        <th class="has-text-right " width="5%">
                          10
                        </th>
                        <th class="has-text-right " width="5%">
                          11
                        </th>
                        <th class="has-text-right " width="5%">
                          12
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="zone in zoneProductivityList" :key="zone.ID">
                        <td>
                          {{ zone.NAME }}
                        </td>
                        <td class="has-text-right">
                          {{ zone.M01 }}
                        </td>
                        <td class="has-text-right">
                          {{ zone.M02 }}
                        </td>
                        <td class="has-text-right">
                          {{ zone.M03 }}
                        </td>
                        <td class="has-text-right">
                          {{ zone.M04 }}
                        </td>
                        <td class="has-text-right">
                          {{ zone.M05 }}
                        </td>
                        <td class="has-text-right">
                          {{ zone.M06 }}
                        </td>
                        <td class="has-text-right">
                          {{ zone.M07 }}
                        </td>
                        <td class="has-text-right">
                          {{ zone.M08 }}
                        </td>
                        <td class="has-text-right">
                          {{ zone.M09 }}
                        </td>
                        <td class="has-text-right">
                          {{ zone.M10 }}
                        </td>
                        <td class="has-text-right">
                          {{ zone.M11 }}
                        </td>
                        <td class="has-text-right">
                          {{ zone.M12 }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </b-tabs>
              </b-field>
            </div>
          </div>
        </b-tab-item>
        <b-tab-item label="ອັດຕາສ່ວນແນວພັນ">
          <div class="columns scrollme">
            <div class="column">
              <b-field :label="tabseedtitle">
                <b-tabs v-model="activeSubTab">
                  <table class="table is-fullwidth is-narrow is-small">
                    <thead>
                      <tr>
                        <th class="has-text-left " width="15%">
                          ໂຊນຜະລິດກະສິກຳ
                        </th>
                        <th class="has-text-right " width="5%">
                          01
                        </th>
                        <th class="has-text-right " width="5%">
                          02
                        </th>
                        <th class="has-text-right " width="5%">
                          03
                        </th>
                        <th class="has-text-right " width="5%">
                          04
                        </th>
                        <th class="has-text-right " width="5%">
                          05
                        </th>
                        <th class="has-text-right " width="5%">
                          06
                        </th>
                        <th class="has-text-right " width="5%">
                          07
                        </th>
                        <th class="has-text-right " width="5%">
                          08
                        </th>
                        <th class="has-text-right " width="5%">
                          09
                        </th>
                        <th class="has-text-right " width="5%">
                          10
                        </th>
                        <th class="has-text-right " width="5%">
                          11
                        </th>
                        <th class="has-text-right " width="5%">
                          12
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="zone in zoneSeedList" :key="zone.ID">
                        <td>
                          {{ zone.NAME }}
                        </td>
                        <td class="has-text-right">
                          {{ zone.M01 }}
                        </td>
                        <td class="has-text-right">
                          {{ zone.M02 }}
                        </td>
                        <td class="has-text-right">
                          {{ zone.M03 }}
                        </td>
                        <td class="has-text-right">
                          {{ zone.M04 }}
                        </td>
                        <td class="has-text-right">
                          {{ zone.M05 }}
                        </td>
                        <td class="has-text-right">
                          {{ zone.M06 }}
                        </td>
                        <td class="has-text-right">
                          {{ zone.M07 }}
                        </td>
                        <td class="has-text-right">
                          {{ zone.M08 }}
                        </td>
                        <td class="has-text-right">
                          {{ zone.M09 }}
                        </td>
                        <td class="has-text-right">
                          {{ zone.M10 }}
                        </td>
                        <td class="has-text-right">
                          {{ zone.M11 }}
                        </td>
                        <td class="has-text-right">
                          {{ zone.M12 }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </b-tabs>
              </b-field>
            </div>
          </div>
        </b-tab-item>
        <b-tab-item label="ຄຳແນະນຳການຜະລິດ">
          <div class="columns scrollme">
            <div class="column">
              <b-field :label="tabrecommendtitle">
                <b-tabs v-model="activeSubTab">
                  <div class="columns">
                    <div class="column">
                      <table class="table is-fullwidth is-narrow is-small">
                        <tr>
                          <td width="10%">ໂຊນກະສິກຳ</td>
                          <td width="10%">ຂັ້ນຕອນ</td>
                          <td width="5%" class="has-text-right">01</td>
                          <td width="5%" class="has-text-right">02</td>
                          <td width="5%" class="has-text-right">03</td>
                          <td width="5%" class="has-text-right">04</td>
                          <td width="5%" class="has-text-right">05</td>
                          <td width="5%" class="has-text-right">06</td>
                          <td width="5%" class="has-text-right">07</td>
                          <td width="5%" class="has-text-right">08</td>
                          <td width="5%" class="has-text-right">09</td>
                          <td width="5%" class="has-text-right">10</td>
                          <td width="5%" class="has-text-right">11</td>
                          <td width="5%" class="has-text-right">12</td>
                        </tr>
                        <tr v-for="zone in zoneRecommendList" :key="zone.ID">
                          <td>
                            {{ zone.NAME }}
                          </td>
                          <td>
                            <b-field class="preproductionstep">
                              ກະກຽມດິນ
                            </b-field>
                            <b-field class="preproductionstep">
                              ກະກຽມແນວພັນ
                            </b-field>
                            <b-field class="preproductionstep">
                              ເລີ່ມຜະລິດ
                            </b-field>
                          </td>
                          <td width="5%" class="has-text-right">
                            <b-field>
                              {{ zone.M01S1 }}
                            </b-field>
                            <b-field>
                              {{ zone.M01S2 }}
                            </b-field>
                            <b-field>
                              {{ zone.M01S3 }}
                            </b-field>
                          </td>
                          <td width="5%" class="has-text-right">
                            <b-field>
                              {{ zone.M02S1 }}
                            </b-field>
                            <b-field>
                              {{ zone.M02S2 }}
                            </b-field>
                            <b-field>
                              {{ zone.M02S3 }}
                            </b-field>
                          </td>
                          <td width="5%" class="has-text-right">
                            <b-field>
                              {{ zone.M03S1 }}
                            </b-field>
                            <b-field>
                              {{ zone.M03S2 }}
                            </b-field>
                            <b-field>
                              {{ zone.M03S3 }}
                            </b-field>
                          </td>
                          <td width="5%" class="has-text-right">
                            <b-field>
                              {{ zone.M04S1 }}
                            </b-field>
                            <b-field>
                              {{ zone.M04S2 }}
                            </b-field>
                            <b-field>
                              {{ zone.M04S3 }}
                            </b-field>
                          </td>
                          <td width="5%" class="has-text-right">
                            <b-field>
                              {{ zone.M05S1 }}
                            </b-field>
                            <b-field>
                              {{ zone.M05S2 }}
                            </b-field>
                            <b-field>
                              {{ zone.M05S3 }}
                            </b-field>
                          </td>
                          <td width="5%" class="has-text-right">
                            <b-field>
                              {{ zone.M06S1 }}
                            </b-field>
                            <b-field>
                              {{ zone.M06S2 }}
                            </b-field>
                            <b-field>
                              {{ zone.M06S3 }}
                            </b-field>
                          </td>
                          <td width="5%" class="has-text-right">
                            <b-field>
                              {{ zone.M07S1 }}
                            </b-field>
                            <b-field>
                              {{ zone.M07S2 }}
                            </b-field>
                            <b-field>
                              {{ zone.M07S3 }}
                            </b-field>
                          </td>
                          <td width="5%" class="has-text-right">
                            <b-field>
                              {{ zone.M08S1 }}
                            </b-field>
                            <b-field>
                              {{ zone.M08S2 }}
                            </b-field>
                            <b-field>
                              {{ zone.M08S3 }}
                            </b-field>
                          </td>
                          <td width="5%" class="has-text-right">
                            <b-field>
                              {{ zone.M09S1 }}
                            </b-field>
                            <b-field>
                              {{ zone.M09S2 }}
                            </b-field>
                            <b-field>
                              {{ zone.M09S3 }}
                            </b-field>
                          </td>
                          <td width="5%" class="has-text-right">
                            <b-field>
                              {{ zone.M10S1 }}
                            </b-field>
                            <b-field>
                              {{ zone.M10S2 }}
                            </b-field>
                            <b-field>
                              {{ zone.M10S3 }}
                            </b-field>
                          </td>
                          <td width="5%" class="has-text-right">
                            <b-field>
                              {{ zone.M11S1 }}
                            </b-field>
                            <b-field>
                              {{ zone.M11S2 }}
                            </b-field>
                            <b-field>
                              {{ zone.M11S3 }}
                            </b-field>
                          </td>
                          <td width="5%" class="has-text-right">
                            <b-field>
                              {{ zone.M12S1 }}
                            </b-field>
                            <b-field>
                              {{ zone.M12S2 }}
                            </b-field>
                            <b-field>
                              {{ zone.M12S3 }}
                            </b-field>
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>
                </b-tabs>
              </b-field>
            </div>
          </div>
        </b-tab-item>
      </b-tabs>
    </div>
  </section>
</template>

<script>
import RestAPI from "../../RestAPI";
import Multiselect from "vue-multiselect";

export default {
  components: { Multiselect },
  props: ["MONTH"],
  data() {
    return {
      roleid: null,
      userName: null,
      selectedType: null,
      typeList: [],

      activeproducts: [],
      productid: null,
      oldproductname: null,
      productname: null,
      oldunit: null,
      unit: null,
      oldphotoname: null,

      selectedFile: null,
      url: "uploadimage", // function name in api site
      photoname: null,
      photopath:
        process.env.NODE_ENV === "production"
          ? "https://agrilao.com/manager-main/api/uploads/products/"
          : "http://localhost/manager/api/uploads/products/",
      // photopath: process.env.NODE_ENV === "production" ? "http://51.222.85.54/agrilao-manager/api/uploads/products/" : "http://localhost/agrilao-manager/api/uploads/products/",
      photopreview: null,
      isSelectPhoto: false,

      activeTab: 0,
      saveAction: true,
      updateAction: false,
      adddataform: true,
      updatedataform: false,

      tabproductivitytitle: null,
      tabseedtitle: null,
      tabrecommendtitle: null,
      provinceList: [],
      activeSubTab: 0,
      zoneProductivityList: [],
      zoneSeedList: [],
      zoneRecommendList: [],
      zoneMonthStatus: "",
      selectedProductID: null,

      selectedTypeSearch: null,
      search: null,
      selectedHarvestSearch: null,

      harvesttype: [
        { ID: "1", NAME: "ຄັ້ງດຽວ" },
        { ID: "0", NAME: "ຫຼາຍເທື່ອ" },
      ],
    };
  },
  methods: {
    getProducts() {
      RestAPI.getClinicProducts("farming")
        .then((res) => {
          // console.log("list:"+ JSON.stringify(res.data))
          this.activeproducts = res.data.activeproducts;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },

    productivityForm(data) {
      this.activeTab = 1;

      this.selectedProductID = data.PRODUCTID;
      this.getAll(this.username, data.PRODUCTID, data.PRODUCTNAME);
    },

    saveProductivity() {
      this.$swal({
        title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "ຕ້ອງການ",
        cancelButtonText: "ບໍ່ຕ້ອງການ",
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
      }).then((result) => {
        if (result.value) {
          var params = {
            zonedata: this.zoneProductivityList,
            productid: this.selectedProductID,
            username: this.username,
          };
          console.log("params: " + JSON.stringify(params));

          RestAPI.saveProductivity(params)
            .then((res) => {
              console.log("res: " + JSON.stringify(res.data));
              this.$swal("ບັນທືກລາຍການ ສຳເລັດ!", "", "success");
            })
            .catch((error) => {
              console.log(error);
              if (error == "Error: Request failed with status code 400") {
                this.$swal("Check Input Data", "", "error");
              } else {
                this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
              }
            });
        }
      });
    },

    seedForm(data) {
      this.activeTab = 2;

      this.selectedProductID = data.PRODUCTID;
      this.getAll(this.username, data.PRODUCTID, data.PRODUCTNAME);
    },

    saveSeed() {
      this.$swal({
        title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "ຕ້ອງການ",
        cancelButtonText: "ບໍ່ຕ້ອງການ",
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
      }).then((result) => {
        if (result.value) {
          var params = {
            zonedata: this.zoneSeedList,
            productid: this.selectedProductID,
            username: this.username,
          };
          console.log("params: " + JSON.stringify(params));

          RestAPI.saveSeed(params)
            .then((res) => {
              console.log("res: " + JSON.stringify(res.data));
              this.$swal("ບັນທືກລາຍການ ສຳເລັດ!", "", "success");
            })
            .catch((error) => {
              console.log(error);
              if (error == "Error: Request failed with status code 400") {
                this.$swal("Check Input Data", "", "error");
              } else {
                this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
              }
            });
        }
      });
    },

    recommendForm(data) {
      this.activeTab = 3;

      this.selectedProductID = data.PRODUCTID;
      this.getAll(this.username, data.PRODUCTID, data.PRODUCTNAME);
    },

    saveRecommend() {
      this.$swal({
        title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "ຕ້ອງການ",
        cancelButtonText: "ບໍ່ຕ້ອງການ",
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
      }).then((result) => {
        if (result.value) {
          var params = {
            zonedata: this.zoneRecommendList,
            productid: this.selectedProductID,
            username: this.username,
          };
          console.log("params: " + JSON.stringify(params));

          RestAPI.saveRecommend(params)
            .then((res) => {
              console.log("res: " + JSON.stringify(res.data));
              this.$swal("ບັນທືກລາຍການ ສຳເລັດ!", "", "success");
            })
            .catch((error) => {
              console.log(error);
              if (error == "Error: Request failed with status code 400") {
                this.$swal("Check Input Data", "", "error");
              } else {
                this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
              }
            });
        }
      });
    },
    getImgUrl(photoname) {
      var photopreview = photoname
        ? this.photopath + photoname
        : this.photopath + "unknown.png";
      // console.log("photoname: " + photoname)
      // console.log("photopreview: " + photopreview)
      return photopreview;
    },

    getAll(username, productid, productname) {
      this.getZoneProductivity(username, productid);
      this.getZoneSeed(username, productid);
      this.getZoneRecommend(username, productid);

      this.tabrecommendtitle =
        "ຄຳແນະນຳການຜະລິດ: " + productname + " (ຈຳນວນວັນດຳເນີນການ)";
      this.tabseedtitle = "ອັດຕາສ່ວນແນວພັນ: " + productname + " (ກຼາມ/ຕາແມັດ)";
      this.tabproductivitytitle =
        "ຄວາມສາມາດຜະລິດ: " + productname + " (ກິໂລ/ຕາແມັດ)";
    },

    getZoneProductivity(username, productid) {
      RestAPI.getZoneProductivity(username, productid, this.type)
        .then((res) => {
          this.zoneProductivityList = res.data;
          console.log("zoneList: " + JSON.stringify(this.zoneList));
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },

    getZoneSeed(username, productid) {
      RestAPI.getZoneSeed(username, productid, this.type)
        .then((res) => {
          this.zoneSeedList = res.data;
          console.log("zoneSeedList: " + JSON.stringify(this.zoneSeedList));
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },

    getZoneRecommend(username, productid) {
      RestAPI.getZoneRecommend(username, productid, this.type)
        .then((res) => {
          this.zoneRecommendList = res.data;
          console.log(
            "zoneRecommendList: " + JSON.stringify(this.zoneRecommendList)
          );
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },

    getProductTypes() {
      RestAPI.getClinicProductTypes("farming")
        .then((res) => {
          // console.log("getClinicProductTypes: " + JSON.stringify(res.data));
          this.typeList = res.data;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },

    productSearch() {
      this.selectedTypeSearch = null;
      // this.search = null;
      this.selectedHarvestSearch = null;

      if (this.search) {
        var params = {
          search: this.search,
        };
        RestAPI.searchClinicProducts(params)
          .then((res) => {
            this.activeproducts = res.data.activeproducts;
            this.inactiveproducts = res.data.inactiveproducts;
            // console.log("products: " + JSON.stringify(this.products));
          })
          .catch((error) => {
            console.log(error);
            this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
          });
      } else {
        this.getProducts();
      }
    },
    productTypeSelectedSearch() {
      // console.log("productTypeSelectedSearch");
      // console.log("this.selectedTypeSearch.ID: " + this.selectedTypeSearch.ID);
      // this.selectedTypeSearch = null;
      this.search = null;
      this.selectedHarvestSearch = null;
      if (this.selectedTypeSearch) {
        var params = {
          typeid: this.selectedTypeSearch.ID,
        };
        RestAPI.clinicProductTypeSelectedSearch(params)
          .then((res) => {
            this.activeproducts = res.data;
            console.log("res: " + JSON.stringify(res.data));
          })
          .catch((error) => {
            console.log(error);
            this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
          });
      } else {
        this.getProducts();
      }
    },
    onHarvestSearch() {
      this.selectedTypeSearch = null;
      this.search = null;
      // this.selectedHarvestSearch = null;

      // console.log("this.selectedHarvestSearch.ID: " + this.selectedHarvestSearch.ID);

      if (this.selectedHarvestSearch) {
        var params = {
          typeid: this.selectedHarvestSearch.ID,
        };
        RestAPI.clinicProductHarvestSelectedSearch(params)
          .then((res) => {
            this.activeproducts = res.data;
            console.log("res: " + JSON.stringify(res.data));
          })
          .catch((error) => {
            console.log(error);
            this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
          });
      } else {
        this.getProducts();
      }
    },

    print() {
      window.print();
    },
  },
  mounted() {
    this.roleid = this.user.ROLEID;
    this.username = this.user.USERNAME;
    this.type = this.roleid == 9 ? "all" : "branch";

    this.getProducts();
    this.getProductTypes();
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.preproductionstep {
  height: 35px;
}
</style>
